import React from 'react';

import { Chip, Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core/react/i18n';

import { capitalizeTopic } from 'src/app/shared/utils/topic';

import { useCuratedTopicsSection } from './hooks';

export const CuratedTopicsSection: React.FC = () => {
	const { topics } = useCuratedTopicsSection();

	return (
		<div className="text-typography-strong space-y-6" data-qa="topic-sitemap-curated-topics">
			<Text as="h2" variant="heading" size="small">
				<Translate value="corgi.topic_page_sitemap.curated_topics.title" />
			</Text>

			<div className="flex flex-wrap gap-2">
				{topics.map((topic) => (
					<Chip
						key={topic.slug}
						data-qa={`${topic.slug}-topic`}
						as="a"
						size="large"
						href={`/topic/${encodeURIComponent(topic.slug)}?source_location=topic-sitemap-curated-topics`}
					>
						{capitalizeTopic(topic.name)}
					</Chip>
				))}
			</div>
		</div>
	);
};
